function galleryMenu() {
    /// <summary>
    /// This object does the complete menu handling in the gallery <br/>
    /// It loads the Gallery bases on the Menu Item. 
    /// Author: MWI<br />
    /// Date: 30.11.2015<br />
    /// Copyright ©: EUDT GmbH 2015 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.2 - 19.01.2018                                               *<br />
    /// **********************************************************************<br />
    /// *- editable for ws-calls better integrated                          *<br />
    /// **********************************************************************<br />
    /// *** v1.0.1 - 06.04.2017                                              *<br />
    /// **********************************************************************<br />
    /// * -  bug with button-active and button-toggle-active fixed           *<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 30.10.2015                                              *<br />
    /// **********************************************************************<br />
    /// * -  inherited from templatejs                                       *<br />
    /// **********************************************************************<br />
    /// </summary>
    this.menuRights = {};
}

//create the prototype based on the rampMenu Object
galleryMenu.prototype = new window.vcTemplate();


galleryMenu.prototype.loadGallery = function (event) {
    ///<summary>               
    ///loads the gallery with the current settings based on the event
    ///where the event can come from anywhere
    ///</summary>
    var me = this;
    try {
        if (me.error) {
            return;
        }
        var signalParam = {assID: -1,assTypeID: -1};
        var widget = "WIDGET_GALLERY";
        if (event.values.mediaCategory === "PRIVATE") {
            widget += "_USER";
        }

        window.VisualCoreService.getVisualContentByName(widget,"gallery",window.getCurrentTimestamp(),500,900,JSON.stringify(event.values),JSON.stringify(signalParam),2,
            function(result) {
                me.visual.find("#divGallery").html(result);
            });

    } catch (ex) {
        me.error = true;
        me.writeError("galleryMenu.loadGallery", ex);
    }
};
galleryMenu.prototype.init = function () {
    ///<summary>
    ///prepares the gallery by setting the user rightsn and starting with
    /// the first list item it can find
    ///</summary>
    var me = this;
    try {
        if (me.error) {
            return;
        }
        me.getUserRights();
        if (me.mobile === true) {
            me.visual.toggleClass("mb");
        }
        me.visual.find("#selNewWidget").off("click").on("click",function () { me.clickNewButton(); });
        me.visual.find("#divMediaMenu .button-toggle").not("#selNewWidget").off("click").on("click",function () {me.selectGalleryType(this);});
        me.visual.find(".button-toggle:first-child").trigger("click");

        me.setInterval();
    } catch (ex) {
        me.error = true;
        me.writeError("galleryMenu.init", ex);
    }
};
galleryMenu.prototype.clickNewButton = function () {
    ///<summary>
    ///handles the menu new button click event
    ///</summary>
    var me = this;
    try {
        if (me.event.values.editable === true) {
            window._VCMQ.produce(me.visual,
                me.vcgid,
                "GAL_EDIT_FILE",
                { "id": -1, "category": me.event.values.mediaCategory, "VCGID": me.vcgid, "editable": me.event.values.editable });
        } else {
            me.showMessage(me.resources.noRightToUpload,  false);
        }
    } catch (ex) {
        me.error = true;
        me.writeError("galleryMenu.clickNewButton", ex);
    }
};
galleryMenu.prototype.selectGalleryType = function(element) {
    ///<summary>
    ///handles the menu element type click event
    ///</summary>
    var me = this;
    try {
        if (me.error) {
            return;
        }

        me.visual.find(".button-toggle").removeClass("button-toggle-active");
        $(element).addClass("button-toggle-active");
        if (me.menuRights[$(element).addClass("button-toggle-active").data("id")].editable === false) {
            me.visual.find("#selNewWidget").css({"opacity":0.5, "cursor":"not-allowed"});
        } else {
            me.visual.find("#selNewWidget").css({ "opacity": 1, "cursor": "pointer" });

        }
        me.setInterval();
    } catch (ex) {
        me.error = true;
        me.writeError("galleryMenu.selectGalleryType", ex);

    }
};
galleryMenu.prototype.getUserRights = function () {
    ///<summary>
    ///prototype function that displays the list item elements
    ///has to work with real user rights, removes not allowed options <br/>
    ///takes the Option and addtionally checks the right to edit values
    ///</summary>
    var me = this;
    var bRet = false;
    try {
        if (!me.error) {
            for (var menu in me.menuRights) {
               if (me.menuRights.hasOwnProperty(menu)) {
      
                    me.visual.find('[data-id="' + menu + '"]').css({ "display": "block" });
                    me.visual.find('[data-id="' + menu + '"] .edit').css({ "opacity": 0.2 });
                }
            }
            me.visual.find(".interval:hidden").remove();
            me.visual.find("#intervalmenu .interval").first().addClass("ui-selected");
            bRet = true;
        }
    } catch (ex) {
        me.error = true;
        me.writeError("galleryMenu.getUserRights", ex);
        bRet = false;
    }
    return bRet;
};

galleryMenu.prototype.doEvent = function (event) {
    ///<summary>
    ///general event function to add the behaviour
    ///so that it does not matter whether the files are shown in FileViewer or as List
    ///</summary>
    var me = this;
    try {
        if (me.error) {
            return;
        }
        switch (event.msg) {
            //view Event
            case "GALMEN_LOAD":
                me.setInterval();

                break;
        }
    } catch (ex) {
        me.error = true;

        me.writeError("galleryMenu.init", ex);

    }
};
galleryMenu.prototype.setInterval = function () {
    /// <summary>
    /// This function sets all needed settings when changing the time interval.<br/>
    /// It changes the data type if it's necessary as well.
    /// </summary>
    var me = this;
    var bRet = false;
    var id, event;
    try {
        if (!me.error) {
            id = me.visual.find(".button-toggle-active").attr("data-id");
            event = { values: { mediaCategory: id, editable: false } };
            event.values.editable = me.menuRights[event.values.mediaCategory].editable;
            me.event = event;
            me.loadGallery(event);
            bRet = true;
        }
    } catch (ex) {
        me.error = true;
        me.writeError("galleryMenu.setInterval", ex);
    }
    return bRet;
};